module.exports = __webpack_public_path__ + "img/select05.56ae64e8.png";